import type { ConfigData } from '@plone/volto/types';
import applySettingsConfig from './config/settings';
import applyMiddlewareConfig from './config/middleware';
import applyPaymentHistorySettings from './config/payment_history';
import applyPaymentHistoryRoutes from './config/payment_history_routes';
import applyMailingListsWidget from './config/mailing_lists';
import applyMyCustomPage from './config/mycustompage';
import subscriptionReducer from './reducers/subscription';
import peachPaymentReducer from './reducers/peachPayment';
import subscriptionsDataReducer from './reducers/subscriptions_data';
import mailingListsReducer from './reducers/mailing_lists';


const applyConfig = (config: ConfigData): ConfigData => {
  // Register reducers
  config.addonReducers = {
    ...config.addonReducers,
    subscription: subscriptionReducer,
    subscriptions_data: subscriptionsDataReducer,
    peachPayment: peachPaymentReducer,
    mailingLists: mailingListsReducer,
  };

  // Apply subscriptions_data configuration
  config = applySettingsConfig(config);

  // Apply payment_history config
  config = applyPaymentHistorySettings(config);
  config = applyPaymentHistoryRoutes(config);

  // Apply middleware configuration
  config = applyMiddlewareConfig(config);
  
  // Apply mailing lists configuration
  config = applyMailingListsWidget(config);
  
  // Test
  // config = applyMyCustomPage(config);

  return config;
};

export default applyConfig;

